import * as types from '../mutation-types';
import axios from 'axios';
import Form from 'vform';

const state = {
    form: new Form({
        roles: []
    }),
    roles: [],
    all_roles: [],
    loading: false,
    edit: false,
    users: [],
    page: '',
    currentpage: '',
    search: '',
    user_id: '',
    error: '',
    name: '',
    username: '',
    email: ''
};

const getters = {
    form: state => state.form,
    roles: state => state.roles,
    loading: state => state.loading,
    users: state => state.users,
    edit: state => state.edit,
    page: state => state.page,
    currentpage: state => state.currentpage,
    search: state => state.search,
    user_id: state => state.user_id,
    error: state => state.error,
    name: state => state.name,
    username: state => state.username,
    email: state => state.email,
    all_roles: state => state.all_roles,
};

const actions = {
    async fetchUsers({commit}) {
        commit(types.USER_LOADING, true);
        let uri = `/api/users/${state.search}?page=${state.page}&currentpage=${state.currentpage}`;
        await axios.get(uri).then(async (response) => {
            await commit(types.USERS, response.data);
        }).catch((response) => {
            commit(types.USER_ERROR, response.data);
        })
        commit(types.USER_LOADING, false);
    },
    async fetchAllRoles({commit}) {
        let uri = `/api/users/create`;
        await axios.get(uri).then(async (response) => {
            await commit(types.ALL_ROLES, response.data);
        })
    }
};

const mutations = {
    [types.USER_LOADING](state, boolean) {
        state.loading = boolean;
    },
    [types.USER_PAGE](state, data) {
        state.page = data;
    },
    [types.USER_CURRENTPAGE](state, data) {
        state.currentpage = data;
    },
    [types.USER_SEARCH](state, data) {
        state.search = data;
    },
    [types.USERS](state, data) {
        state.users = data;
    },
    [types.USER_ERROR](state, data) {
        state.error = data;
    },
    [types.USER_EDIT](state, user) {
        state.edit = !state.edit;
        if (state.edit === true) {
            state.form.fill(user);
        }
    },
    [types.ALL_ROLES](state, data) {
        state.all_roles = data;
    },
    [types.USER_ID](state, data) {
        state.user_id = data;
    },
    [types.USER_EENO](state, data) {
        console.log(data);
        state.username = data;
    },
    [types.USER_EMAIL](state, data) {
        console.log(data);
        state.email = data;
    },
    [types.USER_NAME](state, data) {
        console.log(data);
        state.name = data;
    },
    [types.ADD_ROLE](state, role) {
        if (!state.form.roles.includes(role)) {
            state.form.roles.push(role);
        } else {
            let index = state.form.roles.findIndex((detail) => detail === role);
            state.form.roles.splice(index, 1);
        }
    },
    [types.USER_CLEAR](state) {
        state.form.clear();
        state.form.reset();
    }
};

export {
    state,
    getters,
    actions,
    mutations
}
